import { render, staticRenderFns } from "./AbstractAvatar.vue?vue&type=template&id=afe3c332&"
import script from "./AbstractAvatar.vue?vue&type=script&lang=js&"
export * from "./AbstractAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports